import styled from 'styled-components';
export const Wrapper = styled.div`
  text-align: -webkit-center;
`;
export const Quote = styled.div`
  font-size: 4rem;
  margin-bottom: 2rem;
  color: #4e6e29;
`;
